import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(static)/contact/contact.tsx");
